/* Dependencies */
import * as Vue from 'vue';

// Services
import { shopifyService } from '../../Services/ShopifyService/ShopifyService.service';
import { ContentBlock } from './CoffeePicker.model';

// Widgets
import CoffeePicker from './CoffeePicker.vue';

/**
 * Finds instanced of coffee picker tags and creates a coffee picker instance
 */
export const coffeePickerInit = () => {
  // Seelct the wrapper component.
  const coffeePickerElement = document.querySelector('[data-coffee-picker]');
  const coffeePickerPlaceholderElement = document.querySelector(
    '[data-coffee-picker-placeholder]'
  );
  const coffeePickerNoItemsElement = document.querySelector(
    '[data-coffee-picker-no-items]'
  );

  // Ignore if the component is not found.
  if (!coffeePickerElement) return;

  // Ste Collection Id
  let collectionId: string = '7456656';

  // Store the domain
  let domain = window.location.hostname;

  // Handle Dev & Local
  if (
    domain.includes('127.0.0.1') ||
    domain.includes('hasbean-dev.myshopify.com')
  ) {
    collectionId = '265749430315';
  }

  // Retrieve the colleciton and render the component.
  shopifyService.getCollection(collectionId).then((products) => {
    // Hide the placeholder.
    coffeePickerPlaceholderElement.classList.add('tw-hidden');

    // Handle no products
    if (!products || !products.length) {
      coffeePickerNoItemsElement.classList.remove('tw-hidden');
      coffeePickerNoItemsElement.classList.add('tw-flex');
      return;
    }

    // Pull our content blocks from the window.
    const {
      coffeePickerContentBlocks,
    }: { coffeePickerContentBlocks: ContentBlock[] } = window as any;

    // Create The Coffee Picker
    Vue.createApp(CoffeePicker, {
      products: products,
      contentBlocks: coffeePickerContentBlocks,
    }).mount(coffeePickerElement);
  });
};
